<script setup>
/**
 * Stand-in for the site's Nuxt `<PhotoViewer>` inside the admin (live canvas +
 * any rendered GalleryBlock). Forwards the same `v-model` + `images` contract to
 * the admin's self-contained `PhotoLightbox`, so the gallery lightbox actually
 * works while previewing — not just the public site. Registered globally in
 * main.js under the name `PhotoViewer`.
 */
import PhotoLightbox from "@/components/ui/PhotoLightbox.vue";

defineProps({
  modelValue: { default: null },
  images: { type: Array, default: () => [] },
});
defineEmits(["update:modelValue"]);
</script>

<template>
  <PhotoLightbox :model-value="modelValue" :images="images" @update:model-value="$emit('update:modelValue', $event)" />
</template>
